import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Box, Link, Typography } from '@mui/material'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import { fetchResendConfirmationLink } from 'src/redux/identity'
import { fetchTrackEvent, ProductAnalyticsEventTypes } from 'src/redux/productAnalytics'

export const WIZARD_STORAGE_KEY = 'employerUserSignupWizard'

const EmployerUserEmailConfirmationStep = ({ wizardData }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    localStorage.setItem(WIZARD_STORAGE_KEY, JSON.stringify(wizardData))
    dispatch(
      fetchTrackEvent({
        eventName: 'signup_email_confirmation_viewed',
        eventType: ProductAnalyticsEventTypes.ACTION,
        distinctId: wizardData.email,
      }),
    )
  }, [wizardData, dispatch])

  const handleResend = () => {
    dispatch(
      fetchTrackEvent({
        eventName: 'signup_email_resent',
        eventType: ProductAnalyticsEventTypes.BUTTON_CLICK,
        distinctId: wizardData.email,
      }),
    )
    dispatch(fetchResendConfirmationLink({ email: wizardData.email }))
  }

  return (
    <Box sx={{ textAlign: 'center', py: 4 }}>
      <MailOutlineIcon sx={{ fontSize: 64, color: 'primary.main', mb: 2 }} />

      <Typography variant='h5' gutterBottom>
        Check your inbox
      </Typography>

      <Typography variant='body1' color='text.secondary' sx={{ mb: 1 }}>
        We sent a confirmation email to
      </Typography>

      <Typography variant='body1' fontWeight={600} sx={{ mb: 4 }}>
        {wizardData.email}
      </Typography>

      <Typography variant='body2' color='text.secondary' sx={{ mb: 4, maxWidth: 400, mx: 'auto' }}>
        Click the link in the email to verify your email address.
      </Typography>

      <Box>
        <Typography variant='body2' color='text.secondary' component='span'>
          Didn't receive it?{' '}
        </Typography>
        <Link
          component='button'
          variant='body2'
          onClick={handleResend}
          underline='hover'
        >
          Resend confirmation email
        </Link>
      </Box>
    </Box>
  )
}

export default EmployerUserEmailConfirmationStep
